"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getTenant_1 = __importDefault(require("./getTenant"));
var getPlatformUrl = function () {
    if (process.env.CB_PLATFORM_CLIENT_URL)
        return process.env.CB_PLATFORM_CLIENT_URL;
    var tenant = (0, getTenant_1.default)();
    var domain = window.location.host.split('.').slice(1).join('.');
    return "https://".concat(tenant, ".").concat(domain);
};
exports.default = getPlatformUrl;
